import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { adminsApi } from './api/adminsApi';
import { adminRolesApi } from './api/adminRolesApi';
import { bonusGameApi } from './api/bonusGameApi';
import { citiesApi } from './api/citiesApi';
import { noticesApi } from './api/noticesApi';
import { pushTemplatesApi } from './api/pushTemplatesApi';
import { scootersApi } from './api/scootersApi';
import { tabsApi } from './api/tabsApi';
import { sparePartsApi } from './api/sparePartsApi';
import { workshopTasksApi } from './api/workshopTasksApi';
import { batteriesApi } from './api/batteriesApi';
import { driverTasksApi } from './api/driverTasksApi';
import { statisticsApi } from './api/statisticsApi';

import faqReducer from './slices/faqSlice';
import appReducer from './slices/appSlice';
import newsReducer from './slices/newsSlice';
import authReducer from './slices/authSlice';
import tabsReducer from './slices/tabsSlice';
import usersReducer from './slices/usersSlice';
import zonesReducer from './slices/zonesSlice';
import adminsReducer from './slices/adminsSlice';
import citiesReducer from './slices/citiesSlice';
import balanceReducer from './slices/balanceSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import feedbackReducer from './slices/feedbackSlice';
import noticesReducer from './slices/noticesSlice';
import scootersReducer from './slices/scootersSlice';
import settingsReducer from './slices/settingsSlice';
import contractsReducer from './slices/contractsSlice';
import promocodesReducer from './slices/promocodesSlice';
import scooterNotesReducer from './slices/scooterNotesSlice';
import scooterTypesReducer from './slices/scooterTypesSlice';
import rewardPartnerCompanyReducer from './slices/rewardPartnerCompanySlice';
import rewardBonusesReducer from './slices/rewardBonusesSlice';
import fortuneWheelConfigReducer from './slices/fortuneWheelConfigSlice';
import lostScootersReducer from './slices/lostScootersSlice';
import parkingsReducer from './slices/parkingsSlice';
import managementCompaniesReducer from './slices/managementCompaniesSlice';
import touristPlacesReducer from './slices/touristPlacesSlice';

export const store = configureStore({
  reducer: {
    faq: faqReducer,
    app: appReducer,
    news: newsReducer,
    auth: authReducer,
    tabs: tabsReducer,
    zones: zonesReducer,
    users: usersReducer,
    admins: adminsReducer,
    [adminsApi.reducerPath]: adminsApi.reducer,
    [adminRolesApi.reducerPath]: adminRolesApi.reducer,
    cities: citiesReducer,
    [citiesApi.reducerPath]: citiesApi.reducer,
    balance: balanceReducer,
    subscription: subscriptionReducer,
    feedback: feedbackReducer,
    notices: noticesReducer,
    [noticesApi.reducerPath]: noticesApi.reducer,
    settings: settingsReducer,
    scooters: scootersReducer,
    [scootersApi.reducerPath]: scootersApi.reducer,
    contracts: contractsReducer,
    promocodes: promocodesReducer,

    [bonusGameApi.reducerPath]: bonusGameApi.reducer,
    [pushTemplatesApi.reducerPath]: pushTemplatesApi.reducer,
    [tabsApi.reducerPath]: tabsApi.reducer,
    [sparePartsApi.reducerPath]: sparePartsApi.reducer,
    [workshopTasksApi.reducerPath]: workshopTasksApi.reducer,
    [batteriesApi.reducerPath]: batteriesApi.reducer,
    [driverTasksApi.reducerPath]: driverTasksApi.reducer,
    [statisticsApi.reducerPath]: statisticsApi.reducer,

    scooterNotes: scooterNotesReducer,
    scooterTypes: scooterTypesReducer,
    rewardPartnerCompany: rewardPartnerCompanyReducer,
    rewardBonuses: rewardBonusesReducer,
    fortuneWheelConfig: fortuneWheelConfigReducer,
    lostScooters: lostScootersReducer,
    parkings: parkingsReducer,
    managementCompanies: managementCompaniesReducer,
    touristPlaces: touristPlacesReducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      scootersApi.middleware,
      adminsApi.middleware,
      adminRolesApi.middleware,
      citiesApi.middleware,
      noticesApi.middleware,
      bonusGameApi.middleware,
      pushTemplatesApi.middleware,
      tabsApi.middleware,
      sparePartsApi.middleware,
      workshopTasksApi.middleware,
      batteriesApi.middleware,
      driverTasksApi.middleware,
      statisticsApi.middleware
    )
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
